import React from "react";
import Section2 from "./Components/About__me";
import Section1 from "./Components/Section1";
import Section3 from "./Components/What__I__Do";
import "../src/App.css";
import Resume from "./Components/Resume";
import Contact__me from "./Components/Contact__me";
import Portfolio__Projects from "./Components/Portfolio__Projects";
function App() {
  // const Scroll__Animation=(element)=>{
  //   window.scrollTo({
  //     top:element.current.offsetTop,
  //     behavior:'smooth'
  //   });
  // }
  return (
    <div>
      <Section1 />
      <Section2 />
      <Section3 />
      <Resume/>
      <Portfolio__Projects />
      <Contact__me/>
    </div>
  );
}

export default App;
